module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"coach_mark_message":"向上滑動查看 <br /> <b>更多評論</b>","coach_mark_message_pc":"滾動滑鼠或使用鍵盤方向鍵 ⬆️⬇️<br />可查看<b>更多評價</b>","see_more_reviews":"瀏覽評論"}}')
  delete Component.options._Ctor
}
